import { useState } from "react";

const faqs = [
  {
    q: "Who provides professional towing and recovery services near me in Riverside?",
    a: "Exclusive Recovery Inc, operating as Exclusive Towing, provides professional towing and recovery services in Riverside, Moreno Valley, Colton, and throughout the Inland Empire. Founded in 1991, the company is a municipal contract provider for the City of Riverside and is available 24 hours a day, 365 days a year at (951) 682-2003.",
  },
  {
    q: "How much does towing cost in Riverside, CA?",
    a: "Towing costs in Riverside vary based on vehicle type, distance, time of day, and the specific service required. Exclusive Towing provides transparent pricing and accepts U.S. currency and major credit cards. For an accurate quote based on your situation, call (951) 682-2003 and speak directly with a dispatcher.",
  },
  {
    q: "How long does vehicle recovery take in the Inland Empire?",
    a: "Response times depend on your location, current call volume, and the complexity of the recovery. Exclusive Recovery Inc operates 24/7 with multiple facilities across the Inland Empire — including Riverside and Moreno Valley — to minimize response time. Call (951) 682-2003 for current availability and estimated arrival.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-[#f5f5f3] py-24 px-4 md:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#D4AF37]"></div>
            <span className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase">Common Questions</span>
            <div className="w-8 h-px bg-[#D4AF37]"></div>
          </div>
          <h2 className="text-[#0a0a0c] font-black text-4xl md:text-5xl" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white border border-[#e0e0e0] rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-[#fafaf8] transition-colors"
              >
                <span className="text-[#0a0a0c] font-semibold text-base pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center shrink-0">
                  <i className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-[#D4AF37] text-lg`}></i>
                </div>
              </button>
              {open === i && (
                <div className="px-6 pb-5 border-t border-[#f0f0ee]">
                  <p className="text-[#555] text-sm leading-relaxed pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
